import { useEffect, useRef, useState } from "react";

import GuestImg from "../../assets/images/conversations/ep-06-mahesh-babu-guest.webp";
import ThumbImg from "../../assets/images/conversations/006.webp";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";

/* ─────────────────────────────────────────────
   PREFIX: mb-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .mb-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }
  .mb-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  .mb-hero { padding-top: 60px; padding-bottom: 60px; }
  .mb-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .mb-hero__left { display: flex; flex-direction: column; gap: 44px; }
  .mb-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .mb-hero__title.mb-visible { opacity: 1; transform: translateY(0); }
  .mb-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .mb-hero__spotify.mb-visible { opacity: 1; transform: translateY(0); }
  .mb-hero__spotify iframe {
    display: block; width: 100%; height: 152px; border: none; border-radius: 12px;
  }
  .mb-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .mb-hero__right.mb-visible { opacity: 1; transform: translateY(0); }

  .mb-yt-thumb {
    position: relative; width: 100%; border-radius: 12px;
    overflow: hidden; cursor: pointer; display: block; background: #000;
  }
  .mb-yt-thumb img {
    width: 100%; height: auto; display: block;
    border-radius: 12px; transition: opacity 0.3s ease;
  }
  .mb-yt-thumb:hover img { opacity: 0.85; }
  .mb-yt-thumb__play {
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    background: none; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    pointer-events: none;
  }
  .mb-yt-thumb__play img { width: 40px; height: 44px; }
  .mb-yt-iframe-wrap {
    position: relative; width: 100%; padding-bottom: 56.25%;
    height: 0; border-radius: 12px; overflow: hidden;
  }
  .mb-yt-iframe-wrap iframe {
    position: absolute; top: 0; left: 0;
    width: 100%; height: 100%; border: none;
  }

  .mb-body {
    padding-bottom: 100px; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .mb-body.mb-visible { opacity: 1; transform: translateY(0); }
  .mb-body__para {
    font-family: 'Roboto', sans-serif; font-size: 16px;
    font-weight: 400; color: #E2E2E2; line-height: 160%; margin-bottom: 14px;
  }
  .mb-body__para:last-child { margin-bottom: 0; }

  .mb-guest {
    padding-bottom: 100px; text-align: center; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .mb-guest.mb-visible { opacity: 1; transform: translateY(0); }
  .mb-guest__title {
    font-family: 'Montserrat', sans-serif; font-size: 50px;
    font-weight: 700; color: #ffffff; margin-bottom: 60px;
  }
  .mb-guest__photo-bg {
    display: inline-block; width: 445px; height: 500px;
    background: #743FAC; border-radius: 12px; overflow: hidden;
  }
  .mb-guest__photo-bg img {
    width: 100%; height: 100%; object-fit: cover;
    object-position: top center; display: block;
  }
  .mb-guest__name {
    font-family: 'Montserrat', sans-serif; font-size: 32px;
    font-weight: 700; color: #ffffff; margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .mb-inner { padding-left: 32px; padding-right: 32px; }
    .mb-hero { padding-top: 32px; padding-bottom: 48px; }
    .mb-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .mb-hero__title { font-size: 24px; }
    .mb-hero__left { gap: 16px; }
    .mb-guest__title { font-size: 24px; margin-bottom: 24px; }
    .mb-guest__photo-bg { width: 260px; height: 300px; }
    .mb-guest__name { font-size: 24px; margin-top: 18px; }
    .mb-body__para { font-size: 14px; margin-bottom: 12px; }
    .mb-body { padding-bottom: 48px; }
    .mb-guest { padding-bottom: 48px; }
    .mb-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .mb-inner { padding-left: 16px; padding-right: 16px; }
    .mb-hero { padding-top: 51px; padding-bottom: 30px; }
    .mb-hero__grid { grid-template-columns: 1fr; gap: 30px; }
    .mb-hero__left { gap: 30px; }
    .mb-hero__title { font-size: 30px; }
    .mb-body__para { font-size: 16px; margin-bottom: 10px; }
    .mb-guest__title { font-size: 30px; margin-bottom: 20px; }
    .mb-guest__photo-bg { width: 100%; height: 386px; }
    .mb-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .mb-body { padding-bottom: 30px; }
    .mb-guest { padding-bottom: 30px; }
    .mb-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("mb-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

const YT_VIDEO_ID = "cLQLGRk4SEw";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);
  if (playing) {
    return (
      <div className="mb-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 06 Mahesh Babu"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }
  return (
    <div className="mb-yt-thumb" onClick={() => setPlaying(true)} role="button" aria-label="Play video">
      <img src={ThumbImg} alt="EP 06 Mahesh Babu thumbnail" />
      <div className="mb-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

function HeroSection() {
  const titleRef   = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);
  useFadeUp(titleRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="mb-hero">
      <div className="mb-inner">
        <div className="mb-hero__grid">
          <div className="mb-hero__left">
            <h1 ref={titleRef} className="mb-hero__title">
              EP 06 | Candid conversation with Mahesh BABU, MD &amp; CEO at Mahindra Electric Mobility Ltd on their plans to sell 500,000 EVs in India
            </h1>
            <div ref={spotifyRef} className="mb-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/6YydhsL0msfUF8ua95JeRF?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 06 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="mb-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="mb-body">
      <div className="mb-inner">
        <p className="mb-body__para">
          Today's episode features one of the companies that has taken the largest risks in the EV space, and now through its acquisition of Reva has in fact also taken on the mantle of being the oldest player in the EV space in India is Mahindra.
        </p>
        <p className="mb-body__para">
          Mahindra Electric has sold over 32,000 electric vehicles in India. Yes, you heard right, there are already over 32,000 electric vehicles on the road in India today – and these are just from Mahindra, who plan to sell over 500,000 electric vehicles in India by 2025.
        </p>
        <p className="mb-body__para">
          To kick off our 2021 series, Energizing India podcast co-hosts, Trivikram APTE and Sunil BHAMBHANI speak with the MD &amp; CEO of Mahindra Electric, Mahesh BABU. This insightful conversation covered Mahesh's own journey with Mahindra, the company's plans to sell 500,000 EVs in Indian within 5 years, and the fact that Mahindra is focusing these to be 3 and 4 wheeled EVs, the journey so far with the challenges posed by varying charging standards and an ecosystem that has yet to evolve for EVs, battery swap versus charge strategies and how EVs can help provide emergency powers to homes as well.
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="mb-guest">
      <div className="mb-inner">
        <h2 className="mb-guest__title">Our Guest</h2>
        <div>
          <div className="mb-guest__photo-bg">
            <img src={GuestImg} alt="Mahesh Babu" />
          </div>
          <p className="mb-guest__name">Mahesh BABU</p>
        </div>
      </div>
    </section>
  );
}

export default function Ep06MaheshBabu() {
  return (
    <>
      <style>{CSS}</style>
      <div className="mb-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}